module.exports = __webpack_public_path__ + "2956f60d27f2fc3a1335eb0611e32d60.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-10.png
// module id = 2057
// module chunks = 0